// Main site Header mega-menu data — mirrors the SystemsHeader pattern.
// Every entry has a real `href`, every featured CTA has `ctaHref`, every footer
// link has `{label, href}`. External hrefs (http*) auto-open in new tab.

import { ZHELTA_SHOP_URL } from '../mock';

export const MAIN_MENU = {
  systems: {
    label: 'Systems',
    href: '/systems',
    groups: [
      {
        heading: 'MANAGED IT',
        icon: 'AlignJustify',
        items: [
          { label: 'Managed IT Services', icon: 'MonitorSmartphone', href: '/systems/solutions/managed-it-services' },
          { label: 'IT Systems Management', icon: 'Settings2', href: '/systems/solutions/it-systems-management' },
          { label: 'IT Help Desk & Remote Support', icon: 'MessageCircle', href: '/systems/solutions/it-help-desk-remote-support' },
        ],
      },
      {
        heading: 'SECURITY & PROTECTION',
        icon: 'Lock',
        items: [
          { label: 'Cybersecurity Support', icon: 'ShieldCheck', href: '/systems/solutions/cybersecurity-support' },
          { label: 'Backup & Data Protection', icon: 'Database', href: '/systems/solutions/backup-data-protection' },
          { label: 'Surveillance Camera Deployment', icon: 'Camera', href: '/systems/solutions/surveillance-system-deployment' },
        ],
      },
      {
        heading: 'INFRASTRUCTURE',
        icon: 'Settings',
        items: [
          { label: 'Cloud & Infrastructure Support', icon: 'Cloud', href: '/systems/solutions/cloud-infrastructure-support' },
          { label: 'Network Infrastructure', icon: 'Wifi', href: '/systems/solutions/network-infrastructure-management' },
          { label: 'IT Infrastructure Deployment', icon: 'Plane', href: '/systems/solutions/it-infrastructure-deployment' },
        ],
      },
      {
        heading: 'DEVELOPMENT & ADVISORY',
        icon: 'Wrench',
        items: [
          { label: 'Website Development', icon: 'Globe', href: '/systems/solutions/website-development' },
          { label: 'Application Development', icon: 'LayoutGrid', href: '/systems/solutions/application-development' },
          { label: 'IT Consulting & Technology Advisory', icon: 'Key', href: '/systems/solutions/it-consulting-technology-advisory' },
        ],
      },
    ],
    featured: {
      label: 'FEATURED',
      title: 'ZHELTA Systems Platform',
      body: 'Professional IT services designed for individuals, businesses, and organizations.',
      bullets: ['Comprehensive IT management', '24/7 support and monitoring', 'Scalable solutions'],
      cta: 'Explore All Solutions',
      ctaHref: '/systems/solutions',
    },
    footer: [
      { label: 'View Pricing', href: '/systems/pricing' },
      { label: 'Book a Demo', href: '/systems/book-demo' },
      { label: 'Talk to Sales', href: '/systems/contact' },
    ],
  },

  services: {
    label: 'Services',
    href: '/services',
    groups: [
      {
        heading: 'COMPUTING',
        icon: 'Monitor',
        items: [
          { label: 'Laptops & Desktops', icon: 'Laptop', href: '/store/products?category=laptops' },
          { label: 'Workstations', icon: 'MonitorSmartphone', href: '/store/products?category=workstations' },
          { label: 'Tablets & Mobile', icon: 'Smartphone', href: '/store/products?category=tablets' },
        ],
      },
      {
        heading: 'NETWORKING',
        icon: 'Wifi',
        items: [
          { label: 'Routers & Switches', icon: 'Network', href: '/store/products?category=networking' },
          { label: 'Wi-Fi Equipment', icon: 'Wifi', href: '/store/products?category=wifi' },
          { label: 'Cabling & Accessories', icon: 'Cable', href: '/store/products?category=accessories' },
        ],
      },
      {
        heading: 'SECURITY',
        icon: 'ShieldCheck',
        items: [
          { label: 'CCTV Cameras', icon: 'Camera', href: '/store/products?category=cctv' },
          { label: 'Access Control', icon: 'Lock', href: '/store/products?category=access-control' },
          { label: 'Alarm Systems', icon: 'BellRing', href: '/store/products?category=alarms' },
        ],
      },
      {
        heading: 'STORAGE & SERVERS',
        icon: 'Database',
        items: [
          { label: 'Servers', icon: 'Server', href: '/store/products?category=servers' },
          { label: 'NAS & Storage', icon: 'HardDrive', href: '/store/products?category=storage' },
          { label: 'Software & Licenses', icon: 'Package', href: '/store/products?category=software' },
        ],
      },
    ],
    featured: {
      label: 'MARKETPLACE',
      title: 'ZHELTA Marketplace',
      body: 'Shop verified IT hardware, networking gear, and security products with worldwide delivery.',
      bullets: ['Authentic vendor catalog', 'Localized currency & shipping', 'Business invoicing'],
      cta: 'Shop All Products',
      ctaHref: '/services',
    },
    footer: [
      { label: 'Bulk Orders', href: '/store/products' },
      { label: 'Vendor Sign-Up', href: '/services#vendor-signup' },
      { label: 'Talk to Sales', href: '/systems/contact' },
    ],
  },

  academy: {
    label: 'Academy',
    href: '/academy',
    groups: [
      {
        heading: 'CORE PROGRAMS',
        icon: 'GraduationCap',
        items: [
          { label: 'IT Certifications', icon: 'Award', href: '/academy#programs' },
          { label: 'Computer Hardware', icon: 'Cpu', href: '/academy#programs' },
          { label: 'Software Support', icon: 'MonitorCog', href: '/academy#programs' },
        ],
      },
      {
        heading: 'CAREER PATHS',
        icon: 'Briefcase',
        items: [
          { label: 'Cybersecurity', icon: 'ShieldCheck', href: '/academy#programs' },
          { label: 'Programming', icon: 'Code2', href: '/academy#programs' },
          { label: 'IT Logic & Reasoning', icon: 'Brain', href: '/academy#programs' },
        ],
      },
      {
        heading: 'LEARNING TRACKS',
        icon: 'TrendingUp',
        items: [
          { label: 'Beginner — Level 1', icon: 'BookOpen', href: '/academy#tracks' },
          { label: 'Intermediate — Level 2', icon: 'BookOpenCheck', href: '/academy#tracks' },
          { label: 'Advanced — Level 3', icon: 'Trophy', href: '/academy#tracks' },
        ],
      },
      {
        heading: 'RESOURCES',
        icon: 'BookOpen',
        items: [
          { label: 'Student Stories', icon: 'Users', href: '/academy#testimonials' },
          { label: 'Mentor Network', icon: 'LifeBuoy', href: '/academy#why' },
          { label: 'FAQ', icon: 'MessageCircle', href: '/academy#faq' },
        ],
      },
    ],
    featured: {
      label: 'FEATURED',
      title: 'ZHELTA Academy',
      body: 'Practical, expert-led education that takes you from curiosity to certification to employment.',
      bullets: ['Industry-aligned curriculum', 'Flexible schedule, 24/7 mentors', 'Career-ready outcomes'],
      cta: 'Explore All Programs',
      ctaHref: '/academy#programs',
    },
    footer: [
      { label: 'Browse Tracks', href: '/academy#tracks' },
      { label: 'Read Testimonials', href: '/academy#testimonials' },
      { label: 'Apply Now', href: '/academy#programs' },
    ],
  },

  support: {
    label: 'Support',
    href: '/support',
    groups: [
      {
        heading: 'GET HELP',
        icon: 'LifeBuoy',
        items: [
          { label: 'Contact Support', icon: 'MessageCircle', href: '/support#contact-support' },
          { label: 'Submit a Ticket', icon: 'Inbox', href: '/support#submit-a-ticket' },
          { label: 'Live Chat', icon: 'MessageSquare', href: '/support#live-chat' },
        ],
      },
      {
        heading: 'SELF-SERVICE',
        icon: 'BookOpen',
        items: [
          { label: 'Knowledge Base', icon: 'Library', href: '/support#knowledge-base' },
          { label: 'Documentation', icon: 'FileText', href: '/support#documentation' },
          { label: 'System Status', icon: 'Activity', href: '/support#system-status' },
        ],
      },
      {
        heading: 'BUSINESS',
        icon: 'Briefcase',
        items: [
          { label: 'Talk to Sales', icon: 'Headphones', href: '/support#talk-to-sales' },
          { label: 'Schedule a Consultation', icon: 'CalendarClock', href: '/support#schedule-a-consultation' },
          { label: 'Partner Program', icon: 'Users', href: '/support#partner-program' },
        ],
      },
    ],
    featured: {
      label: 'WE&apos;RE HERE',
      title: 'Real human support',
      body: 'Direct access to real people across ZHELTA Systems, Services, and Academy — no chatbots, no runaround.',
      bullets: ['Email, chat, and phone channels', 'Engineers who actually fix things', 'Multi-language support'],
      cta: 'Contact Us Now',
      ctaHref: '/support#contact-support',
    },
    footer: [
      { label: 'Email Us', href: '/support#contact-support' },
      { label: 'Book a Call', href: '/support#schedule-a-consultation' },
    ],
  },

  about: {
    label: 'About Us',
    href: '/about',
    groups: [
      {
        heading: 'COMPANY',
        icon: 'Users',
        items: [
          { label: 'Our Story', icon: 'BookOpen', href: '/about#our-story' },
          { label: 'Mission & Values', icon: 'Target', href: '/about#mission' },
          { label: 'Leadership', icon: 'Award', href: '/about#leadership' },
        ],
      },
      {
        heading: 'JOIN US',
        icon: 'Briefcase',
        items: [
          { label: 'Careers', icon: 'TrendingUp', href: '/about#careers' },
          { label: 'Internships', icon: 'GraduationCap', href: '/about#internships' },
          { label: 'Become a Vendor', icon: 'Package', href: '/about#become-a-vendor' },
        ],
      },
      {
        heading: 'NEWSROOM',
        icon: 'FileText',
        items: [
          { label: 'Press Releases', icon: 'FileText', href: '/about#press' },
          { label: 'Why ZHELTA', icon: 'Award', href: '/about#news' },
        ],
      },
    ],
    featured: {
      label: 'OUR MISSION',
      title: 'Technology for everyone',
      body: 'A technology solution-oriented company supporting individuals and small businesses since 2012, organised into three integrated divisions.',
      bullets: ['12+ years in practice', 'Three integrated divisions', 'Multi-language platform'],
      cta: 'Read Our Story',
      ctaHref: '/about#our-story',
    },
    footer: [
      { label: 'Careers', href: '/about#careers' },
      { label: 'Contact', href: '/#contact' },
    ],
  },
};
